export function navigateToUrl(url: string): void {
  window.location.href = url;
}

export function reloadPage(forceReload?: boolean): void {
  void forceReload;
  window.location.reload();
}
